import React, { useState } from "react";
import { useSearchParams } from 'react-router-dom';
import "./Contact.css";
import { offices } from '../data/site';
import { submitForm } from '../utils/forms';

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');
  const [searchParams] = useSearchParams();
  const initialTopic = searchParams.get('topic') || 'AI Strategy';
  const role = searchParams.get('role');
  const [form, setForm] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    topic: initialTopic,
    message: role ? `I would like to apply for: ${role}` : '',
    website: '',
  });

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setError('');
    try {
      const result = await submitForm('contact', form);
      setSubmitted(true);
      setStatus(result.fallback ? 'fallback' : 'success');
    } catch (err) {
      setError(err.message);
      setStatus('error');
    }
  };

  return (
    <div className="contact-page page-shell">
      <section className="ct-hero section-dark">
        <span className="aurora-orb hero-orb-a" />
        <span className="aurora-orb hero-orb-b" />
        <div className="site-container-wide">
          <span className="section-eyebrow">Contact</span>
          <h1>
            Let's start the <span className="gradient-text serif-accent">conversation.</span>
          </h1>
          <p>
            Tell us your goal, your timeline, or your hardest data problem. A senior practitioner will
            reply — usually within one business day.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="site-container-wide ct-grid">
          <div className="ct-form-wrap professional-card">
            {!submitted ? (
              <form className="professional-form" onSubmit={onSubmit}>
                <h2>Send us a message</h2>
                <div className="ct-row">
                  <div>
                    <label htmlFor="name">Full name</label>
                    <input id="name" name="name" value={form.name} onChange={onChange} required />
                  </div>
                  <div>
                    <label htmlFor="email">Work email</label>
                    <input id="email" name="email" type="email" value={form.email} onChange={onChange} required />
                  </div>
                </div>
                <div className="ct-row">
                  <div>
                    <label htmlFor="company">Company</label>
                    <input id="company" name="company" value={form.company} onChange={onChange} required />
                  </div>
                  <div>
                    <label htmlFor="phone">Phone (optional)</label>
                    <input id="phone" name="phone" value={form.phone} onChange={onChange} />
                  </div>
                </div>
                <label htmlFor="topic">What can we help with?</label>
                <select id="topic" name="topic" value={form.topic} onChange={onChange}>
                  <option>AI Strategy &amp; Operating Model</option>
                  <option>Generative AI &amp; Agents</option>
                  <option>Data Engineering &amp; Lakehouse</option>
                  <option>MLOps &amp; Production AI</option>
                  <option>Analytics, BI &amp; Decision Intelligence</option>
                  <option>Data Governance &amp; Trust</option>
                  <option>Cloud Data Modernization</option>
                  <option>Computer Vision &amp; Edge AI</option>
                  <option>AI Security &amp; Responsible AI</option>
                  <option>Partnership inquiry</option>
                  <option>Career inquiry</option>
                </select>
                <label htmlFor="message">Message</label>
                <textarea id="message" name="message" rows="5" value={form.message} onChange={onChange} required />
                <label className="form-honeypot" htmlFor="contact-website">Website</label>
                <input id="contact-website" name="website" value={form.website} onChange={onChange} tabIndex="-1" autoComplete="off" className="form-honeypot" />
                {error && <p className="form-error">{error}</p>}
                <button type="submit" className="btn-primary-large" disabled={status === 'loading'}>
                  {status === 'loading' ? 'Sending...' : 'Send message'}
                </button>
                <small>We'll never share your details. Read our privacy policy.</small>
              </form>
            ) : (
              <div className="ct-thanks">
                <span className="ct-check">✓</span>
                <h2>{status === 'fallback' ? 'Your email client is ready.' : 'Thank you — your message is on its way.'}</h2>
                <p>{status === 'fallback' ? 'We opened a prepared email because no form endpoint is configured yet. Send it from your email client and a Dalytix partner will reply.' : 'A Dalytix partner will reply within one business day. In the meantime, you can read our latest insights or browse case studies.'}</p>
              </div>
            )}
          </div>

          <aside className="ct-aside">
            <div className="ct-card">
              <h3>General inquiries</h3>
              <a href="mailto:hello@dalytix.com">hello@dalytix.com</a>
              <span>+44 7838 593666</span>
              <span style={{fontSize:'0.82rem',color:'var(--text-muted)',marginTop:'6px'}}>Dalytix LLC HQ, Altrincham WA14 2YQ, United Kingdom</span>
            </div>
            <div className="ct-card">
              <h3>Press &amp; analyst</h3>
              <a href="mailto:press@dalytix.com">press@dalytix.com</a>
            </div>
            <div className="ct-card">
              <h3>Careers</h3>
              <a href="mailto:careers@dalytix.com">careers@dalytix.com</a>
            </div>
            <div className="ct-card">
              <h3>Offices</h3>
              <ul className="ct-offices">
                {offices.map((o) => (<li key={o.city}><strong>{o.city}</strong><span>{o.region}</span></li>))}
              </ul>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
};

export default Contact;
